/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class EquipmentTemplateService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'EquipmentTemplateService\' loaded');
    }
}

export { EquipmentTemplateService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/equipment/service/EquipmentTemplateService.js